import usFlag from "../assets/images/flags/us.jpg"

// Chinese flag - using a data URL for simplicity (red background with yellow stars)
const chinaFlag = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 20'%3E%3Crect fill='%23de2910' width='30' height='20'/%3E%3Cg fill='%23ffde00'%3E%3Cpolygon points='5,2 6.2,5.5 3,3.5 7,3.5 3.8,5.5'/%3E%3Cpolygon points='9,1 9.4,2 8.3,1.5 9.7,1.5 8.6,2' transform='rotate(23 9 1.5)'/%3E%3Cpolygon points='11,2.5 11.4,3.5 10.3,3 11.7,3 10.6,3.5' transform='rotate(46 11 3)'/%3E%3Cpolygon points='11,5 11.4,6 10.3,5.5 11.7,5.5 10.6,6' transform='rotate(70 11 5.5)'/%3E%3Cpolygon points='9,7 9.4,8 8.3,7.5 9.7,7.5 8.6,8' transform='rotate(20 9 7.5)'/%3E%3C/g%3E%3C/svg%3E"

const languages = {
  en: {
    label: "English",
    flag: usFlag,
  },
  zh: {
    label: "中文",
    flag: chinaFlag,
  },
}

export default languages
